module.exports = __webpack_public_path__ + "mobile/img/search_icon.effa9cc3.svg";